module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C99"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C108"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface#page_ix"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Prologue__Hullabaloo#page_1"
    }
  }, [_vm._v("Prologue: Hullabaloo")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__The_Stars_Start_Falling#page_9"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" The Stars Start Falling")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_2__Magic_Cloak#page_16"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Magic Cloak")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_3__Liquid_Forget#page_20"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Liquid Forget")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_4__Vacation#page_26"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Vacation")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Teenage_Babylon#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Teenage Babylon")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__Just_Do_It#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Just Do It")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7__Greenbriar#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Greenbriar")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8__Earthquake#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Earthquake")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_9__Carnations#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" Carnations")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_10__Clubland#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" Clubland")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_11__Throwing_Shapes#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" Throwing Shapes")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_12__Virtuosity#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12.")]), _vm._v(" Virtuosity")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_13__Red_Head#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13.")]), _vm._v(" Red Head")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_14__Nut_Whites#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14.")]), _vm._v(" Nut Whites")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_15__Tropicana#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15.")]), _vm._v(" Tropicana")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_16__Chino_Jam#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16.")]), _vm._v(" Chino Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_17__Regular_Format#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17.")]), _vm._v(" Regular Format")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_18__Good_Mojo#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("18.")]), _vm._v(" Good Mojo")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_19__Wild_Jokers#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("19.")]), _vm._v(" Wild Jokers")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_20__Unforgiven#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("20.")]), _vm._v(" Unforgiven")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_21__Next_to_Merle#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("21.")]), _vm._v(" Next to Merle")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_22__Balance_the_Buzz#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("22.")]), _vm._v(" Balance the Buzz")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_23__Little_Scissor#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("23.")]), _vm._v(" Little Scissor")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_24__Private_Jet#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("24.")]), _vm._v(" Private Jet")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_25__Don_t_Leave#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("25.")]), _vm._v(" Don’t Leave")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_26__Tutus_and_Tiaras#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("26.")]), _vm._v(" Tutus and Tiaras")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_27__Bash_and_Crash#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("27.")]), _vm._v(" Bash and Crash")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_28__Giant_Baby#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("28.")]), _vm._v(" Giant Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_29__Diversions#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("29.")]), _vm._v(" Diversions")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_30__Helicopter#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("30.")]), _vm._v(" Helicopter")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_31__Convertibles#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("31.")]), _vm._v(" Convertibles")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_32__Shrinking__Sinking#page_196",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("32.")]), _vm._v(" Shrinking, Sinking")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_33__Let_s_Have_a_Party#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("33.")]), _vm._v(" Let’s Have a Party")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_34__Falsity#page_208",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("34.")]), _vm._v(" Falsity")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_35__Camouflage#page_215",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("35.")]), _vm._v(" Camouflage")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_36__The_Same_Union#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("36.")]), _vm._v(" The Same Union")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_37__Queen_Bees#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("37.")]), _vm._v(" Queen Bees")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_38__The_Right_Way#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("38.")]), _vm._v(" The Right Way")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_39__Gold_and_Platinum#page_239",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("39.")]), _vm._v(" Gold and Platinum")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_40__Cheerleader#page_245",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("40.")]), _vm._v(" Cheerleader")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_41__Fried_and_Raw#page_251",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("41.")]), _vm._v(" Fried and Raw")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_42__Cookies#page_257",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("42.")]), _vm._v(" Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_43__Ultras#page_262",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("43.")]), _vm._v(" Ultras")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_44__Thingy_in_the_Sky#page_267",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("44.")]), _vm._v(" Thingy in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "C108"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Epilogue_a_Go_Go#page_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue-a-Go-Go")])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Acknowledgments#page_276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/53_A_Note_on_Sources_and_Identifica#page_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note on Sources and Identifications")])])]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Index#page_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0